export const chineseFlashcards = {
  categories: [
    {
      zh: "你好",
      rm: "Nǐ hǎo",
      en: "Hello",
    },
    {
      zh: "您好",
      rm: "Nín hǎo",
      en: "Hello (formal)",
    },
    {
      zh: "早上好",
      rm: "Zǎoshang hǎo",
      en: "Good morning",
    },
    {
      zh: "下午好",
      rm: "Xiàwǔ hǎo",
      en: "Good afternoon",
    },
    {
      zh: "晚上好",
      rm: "Wǎnshàng hǎo",
      en: "Good evening",
    },
    {
      zh: "晚安",
      rm: "Wǎn'ān",
      en: "Good night",
    },
    {
      zh: "再见",
      rm: "Zàijiàn",
      en: "Goodbye",
    },
    {
      zh: "谢谢",
      rm: "Xièxiè",
      en: "Thank you",
    },
    {
      zh: "不客气",
      rm: "Bù kèqì",
      en: "You're welcome",
    },
    {
      zh: "请",
      rm: "Qǐng",
      en: "Please",
    },
    {
      zh: "对不起",
      rm: "Duìbùqǐ",
      en: "Sorry",
    },
    {
      zh: "没关系",
      rm: "Méi guānxi",
      en: "It's okay / Never mind",
    },
    {
      zh: "是",
      rm: "Shì",
      en: "Yes",
    },
    {
      zh: "不是",
      rm: "Bù shì",
      en: "No",
    },
    {
      zh: "好",
      rm: "Hǎo",
      en: "Good / Okay",
    },
    {
      zh: "我不知道",
      rm: "Wǒ bù zhīdào",
      en: "I don't know",
    },
    {
      zh: "我不明白",
      rm: "Wǒ bù míngbái",
      en: "I don't understand",
    },
    {
      zh: "你会说英语吗？",
      rm: "Nǐ huì shuō Yīngyǔ ma?",
      en: "Do you speak English?",
    },
    {
      zh: "你好吗？",
      rm: "Nǐ hǎo ma?",
      en: "How are you?",
    },
    {
      zh: "我很好",
      rm: "Wǒ hěn hǎo",
      en: "I'm fine",
    },
    {
      zh: "你叫什么名字？",
      rm: "Nǐ jiào shénme míngzì?",
      en: "What's your name?",
    },
    {
      zh: "我叫...",
      rm: "Wǒ jiào...",
      en: "My name is...",
    },
    {
      zh: "多少钱？",
      rm: "Duōshao qián?",
      en: "How much is it?",
    },
    {
      zh: "太贵了",
      rm: "Tài guì le",
      en: "It's too expensive",
    },
    {
      zh: "哪里有...？",
      rm: "Nǎlǐ yǒu...?",
      en: "Where is...?",
    },
    {
      zh: "洗手间在哪里？",
      rm: "Xǐshǒujiān zài nǎlǐ?",
      en: "Where is the restroom?",
    },
    {
      zh: "火车站 在哪里？",
      rm: "Huǒchēzhàn zài nǎlǐ?",
      en: "Where is the train station?",
    },
    {
      zh: "飞机场在哪里？",
      rm: "Fēijīchǎng zài nǎlǐ?",
      en: "Where is the airport?",
    },
    {
      zh: "救命啊！",
      rm: "Jiùmìng a!",
      en: "Help!",
    },
    {
      zh: "我需要帮助",
      rm: "Wǒ xūyào bāngzhù",
      en: "I need help",
    },
    {
      zh: "我迷路了",
      rm: "Wǒ mílù le",
      en: "I'm lost",
    },
    {
      zh: "你可以帮我吗？",
      rm: "Nǐ kěyǐ bāng wǒ ma?",
      en: "Can you help me?",
    },
    {
      zh: "请说慢一点",
      rm: "Qǐng shuō màn yīdiǎn",
      en: "Please speak slower",
    },
    {
      zh: "请再说一遍",
      rm: "Qǐng zàishuō yī biàn",
      en: "Please say that again",
    },
    {
      zh: "我不舒服",
      rm: "Wǒ bù shūfu",
      en: "I don't feel well",
    },
    {
      zh: "我需要医生",
      rm: "Wǒ xūyào yīshēng",
      en: "I need a doctor",
    },
    {
      zh: "我要这个",
      rm: "Wǒ yào zhège",
      en: "I want this",
    },
    {
      zh: "我不要这个",
      rm: "Wǒ bù yào zhège",
      en: "I don't want this",
    },
    {
      zh: "很好",
      rm: "Hěn hǎo",
      en: "Very good",
    },
    {
      zh: "不好",
      rm: "Bù hǎo",
      en: "Not good",
    },
    {
      zh: "今天",
      rm: "Jīntiān",
      en: "Today",
    },
    {
      zh: "明天",
      rm: "Míngtiān",
      en: "Tomorrow",
    },
    {
      zh: "昨天",
      rm: "Zuótiān",
      en: "Yesterday",
    },
    {
      zh: "现在",
      rm: "Xiànzài",
      en: "Now",
    },
    {
      zh: "以后",
      rm: "Yǐhòu",
      en: "Later",
    },
    {
      zh: "水",
      rm: "Shuǐ",
      en: "Water",
    },
    {
      zh: "食物",
      rm: "Shíwù",
      en: "Food",
    },
    {
      zh: "茶",
      rm: "Chá",
      en: "Tea",
    },
    {
      zh: "咖啡",
      rm: "Kāfēi",
      en: "Coffee",
    },
    {
      zh: "啤酒",
      rm: "Píjiǔ",
      en: "Beer",
    },
    {
      zh: "多少时间？",
      rm: "Duōshao shíjiān?",
      en: "How much time?",
    },
    {
      zh: "护照",
      rm: "Hùzhào",
      en: "Passport",
    },
    {
      zh: "签证",
      rm: "Qiānzhèng",
      en: "Visa",
    },
    {
      zh: "酒店",
      rm: "Jiǔdiàn",
      en: "Hotel",
    },
    {
      zh: "房间",
      rm: "Fángjiān",
      en: "Room",
    },
    {
      zh: "我想要预订一个房间",
      rm: "Wǒ xiǎng yào yùdìng yīgè fángjiān",
      en: "I want to book a room",
    },
    {
      zh: "好吃",
      rm: "Hǎochī",
      en: "Delicious",
    },
    {
      zh: "太好了",
      rm: "Tài hǎo le",
      en: "Great!",
    },
    {
      zh: "没问题",
      rm: "Méi wèntí",
      en: "No problem",
    },
    {
      zh: "祝你好运！",
      rm: "Zhù nǐ hǎo yùn!",
      en: "Good luck!",
    },
    {
      zh: "玩得开心！",
      rm: "Wán de kāixīn!",
      en: "Have fun!",
    },
    {
      zh: "干杯！",
      rm: "Gānbēi!",
      en: "Cheers!",
    },
    {
      zh: "左边",
      rm: "Zuǒbian",
      en: "Left",
    },
    {
      zh: "右边",
      rm: "Yòubian",
      en: "Right",
    },
    {
      zh: "直走",
      rm: "Zhí zǒu",
      en: "Go straight",
    },
    {
      zh: "近",
      rm: "Jìn",
      en: "Near",
    },
    {
      zh: "远",
      rm: "Yuǎn",
      en: "Far",
    },
    {
      zh: "请问，这个怎么走？",
      rm: "Qǐngwèn, zhège zěnme zǒu?",
      en: "Excuse me, how do I get to...?",
    },
    {
      zh: "请进",
      rm: "Qǐng jìn",
      en: "Please come in",
    },
    {
      zh: "请坐",
      rm: "Qǐng zuò",
      en: "Please sit",
    },
    {
      zh: "请喝茶",
      rm: "Qǐng hē chá",
      en: "Please have some tea",
    },
    {
      zh: "不用了，谢谢",
      rm: "Bùyòng le, xièxiè",
      en: "No, thank you",
    },
    {
      zh: "再见！",
      rm: "Zàijiàn!",
      en: "Goodbye!",
    },
    {
      zh: "没关系",
      rm: "Méi guānxi",
      en: "It's okay / Never mind",
    },
    {
      zh: "没问题",
      rm: "Méi wèntí",
      en: "No problem",
    },
    {
      zh: "小心",
      rm: "Xiǎoxīn",
      en: "Be careful",
    },
    {
      zh: "别碰我！",
      rm: "Bié pèng wǒ!",
      en: "Don't touch me!",
    },
    {
      zh: "我饿了",
      rm: "Wǒ è le",
      en: "I'm hungry",
    },
    {
      zh: "我渴了",
      rm: "Wǒ kě le",
      en: "I'm thirsty",
    },
    {
      zh: "恭喜你！",
      rm: "Gōngxǐ nǐ!",
      en: "Congratulations!",
    },
    {
      zh: "一路顺风！",
      rm: "Yīlù shùnfēng!",
      en: "Have a good trip!",
    },
    {
      zh: "干杯!",
      rm: "Gānbēi!",
      en: "Cheers!",
    },
    {
      zh: "免费吗？",
      rm: "Miǎnfèi ma?",
      en: "Is it free?",
    },
    {
      zh: "无线密码是什么？",
      rm: "Wúxiàn mìmǎ shì shénme?",
      en: "What's the wifi password?",
    },
    {
      zh: "可以拍照吗？",
      rm: "Kěyǐ pāizhào ma?",
      en: "Can I take a picture?",
    },
    {
      zh: "这是什么？",
      rm: "Zhè shì shénme?",
      en: "What is this?",
    },
    {
      zh: "我喜欢这个",
      rm: "Wǒ xǐhuan zhège",
      en: "I like this",
    },
    {
      zh: "我不喜欢这个",
      rm: "Wǒ bù xǐhuan zhège",
      en: "I don't like this",
    },
    {
      zh: "太好了！",
      rm: "Tài hǎo le!",
      en: "That's great!",
    },
    {
      zh: "真可惜！",
      rm: "Zhēn kěxī!",
      en: "What a pity!",
    },
  ],
};
